import GetVendorsData from "../api/GetVendors";
export default async function GetVendors(props) {
  var _res = await GetVendorsData({ ...props, query: props.vendType });
  if (_res.status === 200) {
    var vend = JSON.parse(props._decrypt(_res.data));
    var parsedata = [];
    // eslint-disable-next-line array-callback-return
    vend.map((e) => {
      let n = { value: e.FirmCode, label: e.FirmName, logo: e.webImgLogo };
      parsedata.push(n);
    });
    return parsedata;
  } else {
    return [];
  }
}
